import { onMounted, onBeforeUnmount } from "vue";
import { getSocket } from "@/utils/socket";

export function useSMSSocketListeners(callbacks: {
  onSMSReceived?: (data: any) => void;
  onSMSSent?: (data: any) => void;
  onSMSStatus?: (data: any) => void;
}) {
  let socket: any = null;

  onMounted(() => {
    socket = getSocket();

    if (callbacks.onSMSReceived) {
      socket.on("sms:received", callbacks.onSMSReceived);
    }
    if (callbacks.onSMSSent) {
      socket.on("sms:sent", callbacks.onSMSSent);
    }
    if (callbacks.onSMSStatus) {
      socket.on("sms:status", callbacks.onSMSStatus);
    }
  });

  onBeforeUnmount(() => {
    if (socket) {
      if (callbacks.onSMSReceived) socket.off("sms:received", callbacks.onSMSReceived);
      if (callbacks.onSMSSent) socket.off("sms:sent", callbacks.onSMSSent);
      if (callbacks.onSMSStatus) socket.off("sms:status", callbacks.onSMSStatus);
    }
  });
}
